import { toValue } from 'vue';

/**
 * A utility function that can be utilized within validator functions to determine if a value is defined.
 * @returns returns `false` if the value is `undefined`, `null`, `[]`, `''`, or an invalid Date.
 */
export default function isDefined(value: unknown): boolean {
  value = toValue(value);

  if (value === undefined || value === null) {
    return false;
  }

  if (Array.isArray(value)) {
    return !!value.length;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (typeof value === 'object') {
    for (const _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).trim().length;
}
